import React, { useState } from 'react'
import { Link } from "react-router-dom";
import { GiHamburgerMenu } from 'react-icons/gi';
import { IoMdClose } from 'react-icons/io';
import emailjs from "@emailjs/browser";


const Hadear = () => {
  const [toggle, setToggle] = useState(false);
  const CloseClick = () => {
    setToggle(false);

  };
  const [ismobile, setIsmobile] = useState(0);

  // const { categorytotal } = useSelector((store) => store.categoryAll);


  const [showAbout, setShowAbout] = useState(true);
  const [showInterior, setShowInterior] = useState(true);
  const [showGallery, setShowGallery] = useState(true);

  const closemenu = () => {
    document.getElementById("mytogglebtn").classList.add("collapsed");
    document.getElementById("menu").classList.remove("in");
  };



  const [name, setName] = useState("");
  const [mail, setmail] = useState("");
  const [massages, setMassages] = useState("");
  const [number, setNumber] = useState("");
  const [state, setState] = useState("");
  const [subject, setSubject] = useState("");
  const [city, setCity] = useState("");

  const nameChange = (e) => {
    const value = e.target.value;
    setName(value);
  };
  const stateChange = (e) => {
    const value = e.target.value;
    setState(value);
  };
  const cityChange = (e) => {
    const value = e.target.value;
    setCity(value);
  };
  const subjectChange = (e) => {
    const value = e.target.value;
    setSubject(value);
  };
  const numberChange = (e) => {
    const value = e.target.value;
    setNumber(value);
  };

  const mailChange = (e) => {
    const value = e.target.value;
    setmail(value);
  };
  const massagesChange = (e) => {
    const value = e.target.value;
    setMassages(value);
  };


  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(

      // "service_oumku8k",
      // "template_esy4tqm",
      // "#myForm",
      // "8i7i_APkS7sZ9CqPl"
    )
      .then(
        function (response) {
          console.log("SUCCESS!", response.status, response.text);
          if (response.text === "OK") {
            setName("");
            setmail("");
            setMassages("");
            setNumber("");
            setState("");
            setSubject("");
            setCity("");

          }
        },
        function (error) {
          console.log("FAILED...", error);
        }
      );
  };
  return (
    <>


      <div className='tejbhan1'>
        <marquee className='tejbhan' width="100%" direction="left" height="" style={{ position: "" }}>
          <b className='' style={{ fontSize: "14px", color: "white", marginTop: "90px" }}>
            <b style={{ color: "" }}> ✅ अन्य सुविधा - ECG | USG | X-Ray | ICU | Ventilator । फामेसर्सी । पैथालॉली </b>
            ✅ विशेषज्ञ परामर्श ओ.पी.डी.
            ✅ भर्ती की सुविधा-जनरल वार्ड, सेमी प्राइवेट, प्राइवेट वार्ड
            ✅ माडयूलर O.T. (दूरबीन से ऑपरेशन की सुविधा)
            ✅ आपालकालीन सुविधाएं 24X7
            ✅ सभी प्रकार के ट्रामा का सम्पूर्ण इलाज एवं ऑपरेशन
          </b>
        </marquee>
      </div>

      <header className="header-area stricky abcd"  >
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">
              <div className="outer-box clearfix">
                <div className="logo">
                  <Link to="/">
                    <img src="assets/img/logo_1.png" alt="Awesome Logo" style={{ width: "70px", height: "70px", marginTop: "30px" }} />
                    {/* style={{ width: "90px", height: "70px" }} */}
                    {/* ./assets/public/website/assets/images/Untitled design (12).png */}
                  </Link>
                </div>
                <nav className="main-menu" style={{ marginTop: "36px" }}>
                  <div className="navbar-header">
                    <button
                      id="mytogglebtn"
                      v
                      className="navbar-toggle collapsed"
                      data-toggle="collapse"
                      data-target="#menu"
                      onClick={closemenu}
                    >
                      <span className="icon-bar" />
                      <span className="icon-bar" />
                      <span className="icon-bar" />

                    </button>
                  </div>
                  <div className="navbar-collapse collapse clearfix" id="menu" >
                    <ul className="navigation clearfix" style={{ fontFamily: "Arial, Helvetica, sans-serif;" }} >
                      <li className="current" >
                        <Link to="/" onClick={closemenu} className=''>
                          Home
                        </Link>
                      </li>

                      <li className="dropdown">
                        <Link to="/about-us" onClick={closemenu}>About Us</Link>
                        <ul
                          style={
                            showAbout
                              ? { display: "block" }
                              : { display: "none" }
                          }
                        >

                          <li>
                            <Link to="/about-us" onClick={closemenu}>
                              About Us
                            </Link>
                          </li>

                          <li>
                            <Link to="/faq" onClick={closemenu}>
                              FAQ
                            </Link>
                          </li>
                        </ul>

                        <div
                          className="dropdown-btn"
                          onClick={() => setShowAbout(!showAbout)}
                        ></div>
                      </li>
                      <li className="dropdown">
                        <a to="" onClick={closemenu}>Services</a>
                        <ul
                          style={
                            showAbout
                              ? { display: "block" }
                              : { display: "none" }
                          }
                        >

                          <li>
                            <Link to="/orthopedic" onClick={closemenu}>
                              Orthopedic
                            </Link>
                          </li>
                          <li>
                            <Link to="/general-surgery" onClick={closemenu}>
                              General Surgery
                            </Link>
                          </li>
                          <li>
                            <Link to="/general-medicine" onClick={closemenu}>
                              General Medicine
                            </Link>
                          </li>
                          <li>
                            <Link to="/dental" onClick={closemenu}>
                              Dental
                            </Link>
                          </li>
                        </ul>

                        <div
                          className="dropdown-btn"
                          onClick={() => setShowAbout(!showAbout)}
                        ></div>
                      </li>

                      {/* <li className="">
                        <Link to="/our-doctor" onClick={closemenu}>
                          Our Doctor
                        </Link>
                      </li> */}
                      <li className="">
                        <Link to="/blog" onClick={closemenu}>
                          Our Blog
                        </Link>
                      </li>

                      <li className="">
                        <Link to="/gallery" onClick={closemenu}>
                          Gallery
                        </Link>
                      </li>

                      <li className="">
                        <Link to="/contact-us" onClick={closemenu}>
                          Contact Us
                        </Link>
                      </li>
                      <li className="">
                        <Link to="/contact-us" onClick={closemenu}>
                          Book Appointment
                        </Link>
                      </li>
                    </ul>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  )
}
export default Hadear